let flash = {
  success: function(message) {
    $('.flash.alert-success')
    .text(message)
    .fadeIn(500, function() {
      $(this)
        .delay(1000)
        .fadeOut();
    });
  },
  error: function(message) {
    $('.flash.alert-danger')
    .text(message)
    .fadeIn(500, function() {
      $(this)
        .delay(1000)
        .fadeOut();
    });
  }
}

export default flash;
